<template>
  <v-container
    style="max-width: 400px;"
  >
    <div
      class="d-flex flex-column justify-center align-center"
    >
      <v-img
        src="/logos/vilke_horizontal_transparent_pink.png"
        max-width="52px"
        class="mt-1"
      />

      <v-card-subtitle
        class="caption text-center"
      >
        {{ description }}
      </v-card-subtitle>
    </div>

    <v-card
      class="mx-auto"
    >
      <v-tabs
        centered
        grow
        color="white"
        slider-color="transparent"
        style="border-bottom: 1px solid rgba(0, 0, 0, 0.14);"
      >
        <v-tab
          v-for="(tab, i) in tabs"
          :key="i"
          :to="tab.to"
          active-class="primary"
        >
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <router-view />

      <v-divider
        class="mt-4"
      />

      <v-card-text>
        <v-btn
          color="grey darken-2"
          text
          block
          target="_blank"
          href="https://vilke.co/?utm_source=app_login"
          rel="noopener"
        >
          <span>
            Mikä on Vilke?
          </span>
          <span
            class="font-weight-bold"
            style="margin-top: -8px; margin-left: 4px;"
          >
            &#8599;
          </span>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
const packageJson = require('../../package.json');

export default {
  computed: {
    description() {
      return packageJson.description;
    },

    tabs() {
      return [
        {
          label: 'Kirjaudu',
          to: '/kirjaudu',
        },
        {
          label: 'Rekisteröidy',
          to: '/rekisteroidy',
        },
      ];
    },
  },

  created() {
    this.$router.replace({
      path: this.$route.path,
      query: null,
    });
  },
};
</script>
